import {
  ACTIVE_BASE_LAYER,
  ADD_BASE_LAYER_TO_MAP,
  REMOVE_BASE_LAYER_FROM_MAP,
} from '../actions/actionTypes';

const initialState = [];

const layersBaseMapReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_BASE_LAYER_TO_MAP:
      return [...state, payload];
    case REMOVE_BASE_LAYER_FROM_MAP:
      return state.filter((layer) => layer.title !== payload.title);
    case ACTIVE_BASE_LAYER:
      return payload;
    default:
      return state;
  }
};

export default layersBaseMapReducer;
